import PayWithQuickbuckDetailsModal from "components/shared/Modal/payWithQuickbucksmodals/payWithQuickbuckDetails";
import PayWithQuickbucksCancelModal from "components/shared/Modal/payWithQuickbucksmodals/payWithQuickbucksCancelReason";
import PayWithQuickbucksConfirmationModal from "components/shared/Modal/payWithQuickbucksmodals/payWithQuickbucksConfirmationModal";
import PayWithQuickbucksFailedModal from "components/shared/Modal/payWithQuickbucksmodals/payWithQuickbucksFailedModal";
import PayWithQuickbucksModalSuccess from "components/shared/Modal/payWithQuickbucksmodals/payWithQuickbucksModalSuccess";
import PayWithQuickbucksPinModal from "components/shared/Modal/payWithQuickbucksmodals/payWithQuickbucksPinModal";
import PayWithQuickbucksProgress from "components/shared/Modal/payWithQuickbucksmodals/payWithQuickbucksProgressBarModal";
import PayWithQuickbucksTermsAndCondition from "components/shared/Modal/payWithQuickbucksmodals/payWithQuickbuckTermsAndConditions";
import useDisclosure from "components/shared/Modal/useDisclosure";
import VehicleCanelReasonModal from "components/shared/Modal/vehicleModals/vehicleCancelReasonModal";
import VehicleLoanCancelledModal from "components/shared/Modal/vehicleModals/vehicleLoanCancelledModal";
import VehicleLoanCancellVerificationModal from "components/shared/Modal/vehicleModals/vehicleLoanCancelVerify";
import VehicleLoanProgress from "components/shared/Modal/vehicleModals/vehicleLoanProgressBarModal";
import { UserProfileContext } from "context/user-profile-context";
import { useAppDispatch } from "customHooks/useAppDispatch";
import { useAppSelector } from "customHooks/useAppSelector";
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  createPayLaterInspection,
  createPayLaterRequest,
  payLaterMonthlyRepay,
} from "store/api/pay-with-quickbuck";
import {
  getAllPayLaterVendors,
  getUserPaymentDetail,
} from "store/reducers/pay-with-quickbucks-slice";
import { cancellVehicleRequest } from "store/reducers/vehicle-finance-slice";
import { sanitizeOutput } from "utils/toast-sanitizer";

const PaylaterPayment = () => {
  const [isModalOpenPaymentDetails, setIsModalOpenPaymentDetails] =
    useState(false);
  const [isModalOpenMerchantSuccess, setIsModalOpenMerchantSuccess] =
    useState(false);
  const [isModalOpenMerchantFailed, setIsModalOpenMerchantFailed] =
    useState(false);
  const [tenor, setTenor] = useState("");
  const [isModalOpenProgress, setIsModalOpenProgress] = useState(false);
  const [equity, setEquity] = useState("");
  const [isInspection, setIsInspection] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isModalOpenMerchantTerms, setIsModalOpenMerchantTerms] =
    useState(false);
  const [isModalOpenConfirmationDetails, setIsModalOpenConfirmationDetails] =
    useState(false);
  const [repaymentResponseData, setRepaymentResponseData] = useState("");
  const [pin, setPin] = useState("");
  const [isModalOpenPin, setIsModalOpenPin] = useState(false);
  const [isModalOpenCancelled, setModalOpenCancelled] = useState(false);
  const [isModalOpenVerification, setIsModalOpenVerification] = useState(false);
  const [isModalSuccess, setIsModalSuccess] = useState(false);
  const [isModalOpenSpinnner, setModalOpenSpinnner] = useState(false);

  const [selectedReason, setSelectedReason] = useState("");
  const [selectedReasonId, setSelectedReasonId] = useState("");
  const [isModalOpenCancelReason, setIsModalOpenCancelReason] = useState(false);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  // const PaymentCode = searchParams.get("paymentCode");
  const { paymentCode } = useParams<{ paymentCode?: string }>();
  const PaymentCode = paymentCode;
  const { userType } = useContext(UserProfileContext);
  const user = {
    hasPendingDoc: false,
    pendingDocReview: false,
  };
  const { hasPendingDoc, pendingDocReview } = user || {};

  const [showNotification, setShowNotification] = useState(
    hasPendingDoc || pendingDocReview
  );

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const modalSuccess = useDisclosure();

  const paymentData = useAppSelector(
    (state) => state?.payLaterVendor?.paymentInfo
  );

  const allPayLaterVendors = useAppSelector(
    (state) => state?.payLaterVendor?.payLaterVendors
  );

  const [equityValue, setEquityValue] = useState(
    paymentData?.EquityContribution
  );
  
  // const LoanAmount =
  // Number(paymentData?.Amount) -
  // (Number(equityValue));

  const LoanAmount =
  Number(paymentData?.Amount) -
  (equityValue !== undefined && equityValue !== null ? Number(equityValue) : Number(paymentData?.EquityContribution));



  useEffect(() => {
    if (PaymentCode) {
      setIsModalOpenPaymentDetails(true);
    }
  }, [PaymentCode]);

  const handleTenorSelectChange = async (value: any) => {
    setTenor(value);
    let payload = {
      Amount: Number(paymentData?.Amount),
      Tenor: Number(value),
      EquityContribution: Number(equityValue || paymentData?.EquityContribution),
    };
    setLoading(true);
    try {
      const response = await payLaterMonthlyRepay(payload);
      setLoading(false);
      if (response.Status === 200) {
        setRepaymentResponseData(response?.Data);
        // toast.success(response.Message);
      } else {
        setLoading(false);
        toast.error(sanitizeOutput(response?.Message));
      }
    } catch (error: any) {
      setLoading(false);
      toast.error(sanitizeOutput(error?.response?.data?.Message || error?.message));
      return error.response;
    }
    setLoading(false);
  };

  const handleCancelConfirmation = () => {
    setIsModalOpenVerification(true);
    // setIsModalOpenConfirmationDetails(false);
  };

  const HandleSelectedReason = async (e: any) => {
    setSelectedReason(e.name);
    setSelectedReasonId(e.id);
  };

  const handleInputedCancelReason = (e: any) => {
    setSelectedReason(e.target.value);
  };

  const handleCloseCancelledModal = () => {
    setModalOpenCancelled(false);
  };

  const handleOpenCancelReason = () => {
    setIsModalOpenConfirmationDetails(false);
    setIsModalOpenVerification(false);
    setIsModalOpenCancelReason(true);
  };

  const handleLoanCancelled = () => {
    setIsModalOpenCancelReason(false);
    let payload = {
      PaymentCode: PaymentCode ? PaymentCode : "",
      CancelReason: selectedReason,
    };
    setModalOpenSpinnner(true);
    dispatch(cancellVehicleRequest(payload))
      .unwrap()
      .then(() => {
        setModalOpenSpinnner(false);
        setModalOpenCancelled(true);
      })
      .catch((err: any) => {
        toast.error(sanitizeOutput(err));
        setModalOpenSpinnner(false);
      });
  };

  const goToHistory = () => {
    navigate("/paylater/paylater-history");
  };

  const handleOpenModal = (vendor: any) => {
    setSelectedVendorUrl(vendor.RedirectUrl);
    setIsModalOpen(true);
    // modalSuccess.onOpen()
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setIsModalOpenVerification(false);
    setSelectedVendorUrl("");
  };

  const handlePinChange = (event: any) => {
    setPin(event);
  };

  const handleContinue = () => {
    window.open(selectedVendorUrl, "_blank");
    setIsModalOpen(false);
    setSelectedVendorUrl("");
  };

  const handleOpenMerchantTerms = () => {
    setIsModalOpenPaymentDetails(false);
    setIsModalOpenMerchantTerms(true);
  };

  const handlePinVerification = async (e: React.FormEvent) => {
    e.preventDefault();
    let payload = {
      PaymentCode: PaymentCode,
      LoanAmount: Number(paymentData?.LoanAmount),
      Tenor: Number(tenor || paymentData?.Tenor),
      EquityContribution: Number(equity),
      PinOrToken: pin,
    };
    setIsModalOpenPin(false);
    setIsModalOpenProgress(true);
    try {
      const response = await createPayLaterRequest(payload);
      setIsModalOpenProgress(false);
      if (response?.Status === 200) {
        setIsModalOpenMerchantSuccess(true);
      } else {
        setIsModalOpenPin(true);
        // setIsModalOpenMerchantFailed(true);
        toast.error(sanitizeOutput(response?.Message));
      }
    } catch (error: any) {
      setIsModalOpenProgress(false);
      setIsModalOpenPin(true);
      toast.error(sanitizeOutput(error?.response?.data?.Message || error?.message));
      // setIsModalOpenMerchantFailed(true);
      return error?.response;
    } finally {
      setPin("");
    }
    // }
  };

  const handleMerchantSuccesss = async () => {
    setIsModalOpenMerchantTerms(false);
    setIsModalOpenPin(true);
  };

  const handleCancelSuccess = () => {
    setIsModalOpenMerchantSuccess(false);
  };

  const handleCancelFailed = () => {
    setIsModalOpenMerchantFailed(false);
    setIsModalOpenProgress(false);
  };

  const handleCancelDetails = () => {
    // setIsModalOpenPin(false);
    // setIsModalOpen(false);
    // setIsModalOpenMerchantTerms(false);
    // setIsModalOpenMerchantSuccess(false);
    // setIsModalOpenMerchantFailed(false);
    setIsModalOpenPaymentDetails(false);
    // setIsModalOpenProgress(false);
  };

  const handleBackConfirmation = () => {
    setIsModalOpenConfirmationDetails(false);
    setIsModalOpenPaymentDetails(true);
  };

  const handleCancelTerms = () => {
    setIsModalOpenMerchantTerms(false);
  };

  const handleReturnBack = () => {
    setIsModalOpenConfirmationDetails(true);
    setIsModalOpenMerchantTerms(false);
  };

  const handleGoToTerms = () =>{
    setIsModalOpenPin(false)
    setIsModalOpenMerchantTerms(true);
  }
  const handleCancels = () => {
    setIsModalOpenPin(false);
  };

  const handleModalPin = () => {
    setIsModalOpenMerchantFailed(false);
    setIsModalOpenPin(true);
  };

  useEffect(() => {
    if (
      paymentData &&
      Object.keys(paymentData).length > 0 &&
      paymentData?.Tenor > 0
    ) {
      getMonthlyRepayment();
    }
  }, [paymentData]);

  const getMonthlyRepayment = async () => {
    let payload = {
      Amount: Number(paymentData?.Amount),
      Tenor: paymentData?.Tenor,
      EquityContribution: Number(paymentData?.EquityContribution),
    };
    setLoading(true);
    try {
      const response = await payLaterMonthlyRepay(payload);
      setLoading(false);
      if (response?.Status === 200) {
        setRepaymentResponseData(response.Data);
        // toast.success(response.Message);
      } else {
        setLoading(false);
        toast.error(sanitizeOutput(response.Message));
      }
    } catch (error: any) {
      setLoading(false);
      toast.error(sanitizeOutput(error?.response?.data?.Message || error?.message));
      return error.response;
    }
    setLoading(false);
  };

  const handleMerchantSavePayment = async (value: any) => {
    setEquity(value.EquityContribution);
    let payload = {
      PaymentCode: PaymentCode,
      LoanAmount: Number(LoanAmount),
      Tenor: Number(tenor || paymentData?.Tenor),
      EquityContribution: Number(value.EquityContribution),
      OptInForInspection: isInspection,
      Pin: pin,
    };
    setLoading(true);
    try {
      const response = await createPayLaterInspection(payload);
      setLoading(false);
      if (response?.Status === 200) {
        setIsModalOpenPaymentDetails(false);
        if (PaymentCode) {
          setLoading(true);
          setIsModalOpenProgress(true);
          dispatch(getUserPaymentDetail({ paymentCode: PaymentCode }))
            .unwrap()
            .then(() => {
              setLoading(false);
              setIsModalOpenProgress(false);
              setIsModalOpenConfirmationDetails(true);
              // toast.success(response?.Message);
            })
            .catch((err: any) => {
              toast.error(sanitizeOutput(err));
              setLoading(false);
              setIsModalOpenProgress(false);
            });
        }
      } else {
        setIsModalOpenPaymentDetails(true);
        toast.error(sanitizeOutput(response?.Message));
      }
    } catch (error: any) {
      setLoading(false);
      setIsModalOpenProgress(false);
      setIsModalOpenPaymentDetails(true);
      toast.error(sanitizeOutput(error?.response?.data?.Message || error?.message));
      return error.response;
    }
  };

  const handleMerchantSavePayments = async (value: any) => {
    setIsModalOpenConfirmationDetails(false);
    setIsModalOpenMerchantTerms(true);
  };

  const handleEquityInputChange = async (event: any, formik: any) => {
    const { value } = event.target;
    setEquityValue(+value);
    formik.handleChange(event);
    if (value && (tenor || paymentData?.Tenor)) {
      let payload = {
        Amount: Number(paymentData?.Amount),
        Tenor: Number(tenor || paymentData?.Tenor),
        EquityContribution: Number(value),
      };
      setLoading(true);
      try {
        const response = await payLaterMonthlyRepay(payload);
        setLoading(false);
        if (response.Status === 200) {
          setRepaymentResponseData(response.Data);
          // toast.success(response.Message);
        } else {
          setLoading(false);
          toast.error(sanitizeOutput(response.Message));
        }
      } catch (error: any) {
        setLoading(false);
        toast.error(sanitizeOutput(error?.response?.data?.Message || error?.message));
        return error.response;
      }
      setLoading(false);
    }
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedVendorUrl, setSelectedVendorUrl] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(getAllPayLaterVendors()).unwrap();
      } catch (error) {}
    };

    fetchData();
  }, [dispatch]);

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoToHistory = () => {
    navigate("/paylater-home/paylater-history");
  };
  return (
    <div>
      <PayWithQuickbuckDetailsModal
        isModalOpen={isModalOpenPaymentDetails}
        handleCancel={handleCancelDetails}
        onSelectChange={handleTenorSelectChange}
        openConfirmation={handleMerchantSavePayment}
        onEquityInputChange={handleEquityInputChange}
        loanAmount={LoanAmount}
        equityValue={equityValue}
        isInspection={isInspection}
        loadingApi={loading}
        repaymentResponseData={repaymentResponseData}
        goBack={handleGoBack}
      />

      <PayWithQuickbucksConfirmationModal
        isModalOpen={isModalOpenConfirmationDetails}
        openConfirmation={handleMerchantSavePayments}
        handleCancel={handleCancelConfirmation}
        handleBack={handleBackConfirmation}
        equityValue={equityValue}
        repaymentResponseData={repaymentResponseData}
        tenor={tenor}
      />

      <PayWithQuickbucksTermsAndCondition
        isModalOpen={isModalOpenMerchantTerms}
        openTerms={handleMerchantSuccesss}
        handleCancel={handleCancelTerms}
        returnBack={handleReturnBack}
        goToHistory={goToHistory}
      />

      <PayWithQuickbucksPinModal
        isModalOpen={isModalOpenPin}
        pin={pin}
        onChangePinSelectChange={handlePinChange}
        handleCancel={handleCancels}
        verifyPin={handlePinVerification}
        hideCloseIcon={PaymentCode}
        goToTerms={handleGoToTerms}
      />

      <PayWithQuickbucksProgress isModalOpen={isModalOpenProgress} />

      <PayWithQuickbucksModalSuccess
        isModalOpen={isModalOpenMerchantSuccess}
        handleCancel={handleCancelSuccess}
        goToHistory={handleGoToHistory}
      />

      <PayWithQuickbucksFailedModal
        isModalOpen={isModalOpenMerchantFailed}
        handleCancel={handleCancelFailed}
        isModalOpenDetails={handleModalPin}
        goToHistory={goToHistory}
      />
  
      <PayWithQuickbucksCancelModal
        isModalOpen={isModalOpenCancelReason}
        handleCancel={handleCloseModal}
        handleLoanCancelled={handleLoanCancelled}
        onSelectedReason={HandleSelectedReason}
        inputedCancelReason={handleInputedCancelReason}
        selectedReasonId={selectedReasonId}
      />

      <VehicleLoanCancelledModal
        isModalOpen={isModalOpenCancelled}
        handleCancel={handleCloseCancelledModal}
        goToHistory={goToHistory}
      />

      <VehicleLoanCancellVerificationModal
        openCancelReason={handleOpenCancelReason}
        isModalOpen={isModalOpenVerification}
        handleCancel={handleCloseModal}
      />

      <VehicleLoanProgress
        isModalOpen={isModalOpenSpinnner}
        // handleCancel={handleCancel}
      />
    </div>
  );
};

export default PaylaterPayment;
